import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { Divider, Text } from '../../atoms';

type AvailableWalletBalanceDrawerProps = {
	formattedAltWalletBalance?: string;
	showDivider?: boolean;
	walletBalance: number | undefined;
	walletCurrency: string | undefined;
};

export const AvailableWalletBalanceDrawer = ({
	formattedAltWalletBalance,
	showDivider = true,
	walletBalance,
	walletCurrency
}: AvailableWalletBalanceDrawerProps) => {
	const { $t } = useIntl();

	return (
		<S.WalletBalanceWrapper>
			<S.WalletBalanceContainer>
				<S.WalletBalanceTitle>
					{$t('fanTokenOffering.errorDrawer.insufficientBalance.walletBalance')}
				</S.WalletBalanceTitle>
				<S.WalletBalance>
					<S.Amount variant="text3">
						{$t('fanTokenOffering.errorDrawer.insufficientBalance.balanceAmount', {
							amount: walletBalance?.toFixed(2),
							currency: walletCurrency
						})}
					</S.Amount>
					{formattedAltWalletBalance && <S.Amount variant="text3">{formattedAltWalletBalance}</S.Amount>}
				</S.WalletBalance>
			</S.WalletBalanceContainer>
			{showDivider && <Divider orientation="horizontal" />}
		</S.WalletBalanceWrapper>
	);
};

namespace S {
	export const WalletBalanceWrapper = styled.div`
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const WalletBalanceContainer = styled.div`
		display: flex;
		flex-direction: row;
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
		border-radius: ${({ theme }) => theme.sizing.xxxsmall};
		margin: ${({ theme }) => theme.spacings.small} 0;
		padding: ${({ theme }) => theme.spacings.small};
		${({ theme }) => theme.fonts.text.text3};
	`;

	export const WalletBalanceTitle = styled.div`
		width: 100%;
		color: ${({ theme }) => theme.colors.text.main.enabled};
		display: flex;
		justify-content: start;
		align-items: center;
	`;

	export const WalletBalance = styled.div`
		width: 100%;
		justify-content: center;
		align-items: end;
		flex-direction: column;
		display: flex;
	`;
	export const Amount = styled(Text)`
		color: ${({ theme }) => theme.colors.text.destructive.enabled};
	`;
}
